<ng-container *ngFor="let child of schema.childs">
  <app-expand-resume-group 
    [label]="child.label" 
    [fieldControl]="child.fieldControl | asFormGroup"
    [schema]="child.childs ?? []">
  </app-expand-resume-group>
</ng-container>